import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, CircularProgress, Button, Container, Alert } from '@mui/material';
import { FeedItemCard } from '../components/FeedItemCard';
import { UserSearch } from '../components/UserSearch';
import { useFeed } from '../hooks/useFeed';

/**
 * Social feed page showing recent public trips/pins from followed users.
 */
export function FeedPage() {
  const { t } = useTranslation();
  const { items, isLoading, error, hasMore, loadMore, refresh } = useFeed();

  return (
    <Container maxWidth="sm" sx={{ py: 3 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Feed
      </Typography>

      <Box sx={{ mb: 3 }}>
        <UserSearch />
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} action={<Button onClick={refresh}>{t('feed.retry')}</Button>}>
          {error}
        </Alert>
      )}

      {isLoading && items.length === 0 ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : items.length === 0 ? (
        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ py: 4 }}>
          {t('feed.noPosts')}
        </Typography>
      ) : (
        <>
          {items.map((item) => (
            <FeedItemCard key={item.id} item={item} />
          ))}
          {hasMore && (
            <Box display="flex" justifyContent="center" py={2}>
              <Button onClick={loadMore} disabled={isLoading} variant="outlined">
                {isLoading ? <CircularProgress size={20} /> : t('feed.loadMore')}
              </Button>
            </Box>
          )}
        </>
      )}
    </Container>
  );
}
